<template>
  
        <Swiper  class="w-full h-full"       
        :modules="[Navigation, Pagination, Autoplay, EffectCreative]"
        :navigation="true"
        :pagination="{ clickable: true }"
        :loop="true"
        :effect="'creative'"
        :slides-per-view="1"
        :autoplay="{ delay: 8000 }">
          <SwiperSlide v-for="(item, index) in banner600" :key="index"> 
             <div class=" h-full">  
               <picture >
                   <source 
                   class="w-full h-full object-cover"
                     media="(min-width: 1280.98px)"
                     :srcset="'https://parsinekala.com' + banner1500[index]"/>
                   <source class="object-cover"
                     media="(min-width: 639.98px)"
                    :srcset="'https://parsinekala.com' + banner800[index]"
                   />
                   <img class="w-full h-full object-cover"
                    :src="'https://parsinekala.com' + banner600[index]"
                     :alt="bannerAlt[index]"
                     :aria-label="bannerAlt[index]"
                   />
                 </picture>
               </div>
           </SwiperSlide>
          
        </Swiper>
 

</template>
<script setup>
import { onBeforeMount, onMounted ,defineProps,ref} from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-creative';
import { Navigation, Pagination, Autoplay, EffectCreative } from 'swiper';
const props=defineProps({
  bannerData:{
    type:Array,
    require:true,
  }
})

const banner1500 = ref([]);
const banner800 = ref([]);
const banner600 = ref([]);
const bannerAlt = ref([]);

const setData=()=>{
  
  banner1500.value.length = 0;
  banner800.value.length = 0;
  banner600.value.length = 0;
  bannerAlt.value.length = 0;

  let i = 0;
  let j = 0;
  let k = 0;
  props.bannerData.forEach((item)=>{
    if (item.size === "1500") {
      banner1500.value[i] = item.image;
      i += 1;
    }
    if (item.size === "800") {
      banner800.value[j] = item.image;
      j += 1;
    }
    if (item.size === "600") {
      banner600.value[k] = item.image;
      bannerAlt.value[k] = item.alt;
      k += 1;
    }
  })
}
onBeforeMount(()=>{
  setData();
})
onMounted(()=>{
 
})

</script>